import type { ChartColorRef } from './types'

export const simpleLineChartConfig = {
  line: {
    width: 3,
    shape: 'spline' as const,
    smoothing: 1.3,
    /** Used when `lineColor` prop is not provided. */
    defaultColor: 'primary' as ChartColorRef,
  },

  marker: {
    size: 6,
    show: true,
  },

  grid: {
    show: true,
  },

  colors: {
    title: 'textSecondary' as ChartColorRef,
    axis: 'textSecondary' as ChartColorRef,
    grid: 'border' as ChartColorRef,
    text: 'text' as ChartColorRef,
  },

  layout: {
    margins: {
      withTitle: { t: 40, r: 20, b: 40, l: 50 },
      withTitleAndXLabel: { t: 40, r: 20, b: 50, l: 50 },
      withYLabel: { l: 60 },
    },
    tickangle: -45,
    minTicks: 4,
    maxTicks: 8,
    yTickformat: ',.2f',
    showLegend: false,
  },

  plot: {
    defaultSeriesName: 'Value',
    defaultXLabel: 'Date',
    hoverYFormat: ',.2f',
  },

  defaults: {
    height: '100%' as const,
    width: '100%' as const,
  },
} as const
